/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Usable_AreaInputs */

const cs_form_usable_area = /** @type {(inputs: Form_Usable_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Užitná plocha (m²)`)
};

const en_form_usable_area = /** @type {(inputs: Form_Usable_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usable area (m²)`)
};

/**
* | output |
* | --- |
* | "Usable area (m²)" |
*
* @param {Form_Usable_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_usable_area = /** @type {((inputs?: Form_Usable_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Usable_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_usable_area(inputs)
	return cs_form_usable_area(inputs)
});